import React, { Suspense, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import {
  Loader,
  PageContainer,
  PageHeader,
} from 'src/components/MainPage/_shared/page';
import { periodSalesTabs } from './PeriodSalesTabs';

const paths = periodSalesTabs.map((i) => i.path);

export const PeriodSalesPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!paths.some((path) => location.pathname.includes(path))) {
      navigate(periodSalesTabs[0].path, { replace: true });
    }
  }, [location, navigate]);

  return (
    <PageContainer>
      <PageHeader title="Отчёт по продажам за период" />
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    </PageContainer>
  );
};
